module.exports = __webpack_public_path__ + "img/sjfsc.4961b2e8.png";